define([
	"dojo/_base/declare",
	"dijit/MenuItem",
	"underscore",
	"csi/html",
	"csi/view/ToolbarPlugin"
], function(declare, MenuItem, _, html, ToolbarPlugin) {

	return declare([MenuItem, ToolbarPlugin], {
		/** @property {string} anchorHref - value for anchor href attribute if menu item navigates to page in application */
		anchorHref: "",

		/**
		 * @override
		 * Set appearance based on action
		 */
		postMixInProperties: function() {
			this._mixinActionProperties();
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Ensure label is correct for toggle action based on context
		 */
		postCreate: function() {
			this.inherited(arguments);
			this._updateToggleLabel(this.getView().getContext());
		},

		/**
		 * @override
		 * Update label each time in case context has changed
		 */
		enablePlugin: function(ctx) {
			const b = this.inherited(arguments);

			if (ctx) {
				this._updateToggleLabel(ctx);
			}

			return b;
		},

		/**
		 * @override
		 * React to clicking menu item
		 */
		onClick: function(e, action, params) {
			const {anchorHref} = this;

			if (anchorHref) {
				html.openWindowOnMouseClick(e, anchorHref);
			} else if (!anchorHref) {
				// if no link (!href) then execute action
				this.inherited(arguments, [e, action, Object.assign({}, params, {
					m_bToggle: (this.get("label") == this.defAction.m_nameToggle)
				})]);
			}
		},

		/**
		 * @override
		 * Return HTML for anchor if configured with href
		 */
		_getPluginActionLabel: function(action) {
			// NOTE: this does not support toggling, as only one link is available to configure
			const {anchorHref} = this;
			const label = this.inherited(arguments);
			return anchorHref ? `<a href="${anchorHref}">${label}</a>` : label;
		},

		/**
		 * Update label for toggle actions
		 * @param {Context} ctx
		 */
		_updateToggleLabel: function(ctx) {
			var toggled = this.isToggledInitially(ctx);
			if (toggled !== null) {
				const a = this.defAction;
				this.set("label", _.escape(toggled ? a.m_nameToggle : a.m_name));
			}
		}
	});
});